import React, { createContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Loader from '../../components/Loader/Loader';

import * as actions from '../../store/actions';

export const ThemingContext = createContext(null);

const Theming = ({ children }) => {
  const dispatch = useDispatch();

  const companyId = useSelector((state) => state.user.company_uuid);
  const preferences =
      useSelector((state) => state.preferences.preferences);
  const preferencesResponse = useSelector(
      (state) => state.preferences.response
  );

  useEffect(() => {
    if (companyId) dispatch(actions.getPreferences(companyId));
  }, [companyId, dispatch]);

  const host = window.location.hostname.split('.')
  const hostName = host[0]

  useEffect(() => {
    dispatch(actions.getLoginPreferences(hostName));
  },[hostName, dispatch])


  if (!preferencesResponse && !preferences && companyId) {
    return <Loader />;
  }

  const textPrimary = preferences && preferences.text_primary;
  const textSecondary = preferences && preferences.text_secondary;
  const header = preferences && preferences.header;
  const buttonOutlined = preferences && preferences.button_outline;
  let buttonPrimary = '#003366'
  let bgImage = ''
  let loginStyle = ''
  if(window._app_config.REACT_APP_LOGIN_SETTING){
    const setting = window._app_config.REACT_APP_LOGIN_SETTING.split('|')
    if(setting[1] && setting[1] !== '' ){ bgImage = require('statics/'+setting[1]).default || require('statics/'+setting[1]) }
    if(setting[2] && setting[2] !== '' ){ buttonPrimary = '#'+setting[2] }
    if(setting[5] && setting[5] !== '' ){ loginStyle = '#'+setting[5] }
  }

  const text = {
    primary: {
      color: textPrimary,
    },
    secondary: {
      color: textSecondary,
    },
    bold: {
      color: '#007E7A',
    },
    button: {
      color: buttonPrimary
    }
  };

  const component = {
    login: {
      backgroundImage: `url(${bgImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundColor: loginStyle,
      backgroundSize: '100% 100%',
    },
    header: {
      backgroundRepeat: 'no-repeat',
      backgroundColor: header,
    },
    button: {
      primary: {
        backgroundColor: buttonPrimary,
        borderColor: buttonPrimary
      },
      outlined: {
        borderColor: buttonOutlined,
        color: buttonOutlined,
      },
      plain: {
        color: buttonPrimary,
      },
    },
    checkbox: {
      checkmark: {
        borderColor: buttonPrimary,
      },
      checked: { borderColor: buttonPrimary, backgroundColor: buttonPrimary },
    },
    sidebar: {
      ':hover': {
        color: buttonPrimary
      },
    },
    sidebarActive: {
      color: buttonPrimary
    },
    listBox: {
      color: buttonPrimary,
      borderColor: buttonPrimary,
      ':hover': { backgroundColor: buttonPrimary },
    },
    bubbleBox: {
      item: {
        color: buttonPrimary,
      },
    },
    menuBar: {
      color: buttonPrimary,
      borderColor: buttonPrimary,
    },
    border: {
      borderColor: buttonPrimary,
    }
  };

  return (
      <ThemingContext.Provider value={{ text, component }}>
        {children}
      </ThemingContext.Provider>
  );
};

export default Theming;
